export const getDefaultOptions = ({ selectableRows, visibleItemsCount, totalCount, isMobile, }) => ({
    download: false,
    search: false,
    print: false,
    filter: false,
    viewColumns: false,
    caseSensitive: true,
    confirmFilters: true,
    columnOrder: undefined,
    expandableRows: false,
    page: 0,
    pagination: true,
    rowHover: true,
    sort: false,
    sortFilterList: false,
    serverSide: true,
    elevation: 0,
    selectableRowsHeader: !!selectableRows,
    selectableRows: (selectableRows === true
        ? 'multiple'
        : selectableRows),
    selectableRowsHideCheckboxes: !selectableRows,
    count: selectableRows ? visibleItemsCount : totalCount,
    rowsPerPage: 10,
    responsive: (isMobile ? 'standard' : 'vertical'),
});
